@if (isAuthenticated() && showBanner()) {
  <div class="banner">
    <div class="text">
      <span class="title">{{ 'Settings.Web_Push_Banner_Title' | translate }}</span>
      <span class="message">{{ 'Settings.Web_Push_Banner_Message' | translate }}</span>
    </div>
    <div class="actions">
      <ion-button fill="outline" size="small" (click)="dismiss()">{{ 'Common.Dismiss' | translate }}</ion-button>
      <ion-button size="small" (click)="enable()">{{ 'Settings.Web_Push_Banner_Enable' | translate }}</ion-button>
    </div>
  </div>
}
